/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  // theme: {

  // },
  theme: {
    // defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          primary: '#677694',
          secondary: '#969ead',
        },
      },
      light: {
        colors: {
          primary: '#587ccc',
          secondary: '#9cbbe7',
        },
      },
    },
  },
})
